export default {
  dateToString(_date) {
    let date = _date
    if (!date.getFullYear)
    date = new Date(date)
    var year = date.getFullYear()
  
    var month = (1 + date.getMonth()).toString()
    month = month.length > 1 ? month : '0' + month
  
    var day = date.getDate().toString()
    day = day.length > 1 ? day : '0' + day

    var hour = date.getHours().toString()
    var minutes = date.getMinutes().toString()
    if (minutes.length < 2) minutes = '0' + minutes
    var seconds = date.getSeconds().toString()
    if (seconds.length < 2) seconds = '0' + seconds
    
    return day + '/' + month + '/' + year + ' - ' + hour + ':' + minutes + ':' + seconds
  },
  round: function (num, n = 2) {
    return Number(num).toFixed(n)
  }
}